//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ElectricalRouting.js";
import "../no/Builder.js";
let d=[[[0,"DatasetName",1,0],[0,"ExportMode",1,0],[0,"FileType",1,0],[0,"ItemId",1,0],[0,"ItemRevision",1,0]],[],[]];
SPLM.ElectricalRouting.TeamcenterExporterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ElectricalRouting.TeamcenterExporterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ElectricalRouting.TeamcenterExporterBuilder.DatasetExportMode = Object.freeze({
    "CreateNew" : "CreateNew", "OverwriteExisting" : "OverwriteExisting"});

SPLM.ElectricalRouting.TeamcenterExporterBuilder.ExportFileType = Object.freeze({
    "PlmXml" : "PlmXml", "Zip" : "Zip", "Hrn" : "Hrn", "Cmp" : "Cmp", "Hx2ml" : "Hx2ml"});

export default SPLM;